export default {"src":"/_next/static/media/calendar-frame.83502468.svg","height":42,"width":39,"blurWidth":0,"blurHeight":0};